var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "calendar-event-list-view" },
    [
      _c(
        "div",
        { staticClass: "groups" },
        _vm._l(_vm.getGroups(), function (group) {
          return _c(
            "div",
            { key: group.date, staticClass: "group" },
            [
              _c("div", { staticClass: "group-title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(group.dateLabel) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _vm._l(group.events, function (event) {
                return _c(
                  "div",
                  {
                    key: event._id,
                    staticClass: "event",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.getEventDetail(event)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "hour" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.getEventHourRange(event)) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "metas" }, [
                      _c(
                        "div",
                        { staticClass: "left" },
                        [
                          _c("AgentAvatar", {
                            attrs: {
                              size: 25,
                              userID: event.userId,
                              "font-size": 15,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "right" }, [
                        _c("strong", [_vm._v(_vm._s(event.summary))]),
                        _vm._v(" "),
                        !!event.reservationId
                          ? _c("span", [
                              _vm._v(" " + _vm._s(_vm.getFullname(event))),
                            ])
                          : _c("span", [
                              _vm._v(" " + _vm._s(event.description)),
                            ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "attendees" },
                      _vm._l(event.refUsers, function (refUser) {
                        return _c("AgentAvatar", {
                          key: refUser._id,
                          attrs: {
                            size: 25,
                            "font-size": 15,
                            userID: refUser._id,
                          },
                        })
                      }),
                      1
                    ),
                  ]
                )
              }),
            ],
            2
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.modalVisible
        ? _c("CreateEventModal", {
            attrs: {
              calendarList: _vm.calendarList,
              eventDetail: _vm.eventDetail,
              footerVisible: false,
            },
            on: {
              close: function ($event) {
                _vm.modalVisible = false
              },
              deleteEvent: _vm.deleteEvent,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }